<template>
    <div class="payment-summary payment-summary__card-gap" :class="countryClass">
        <h4 class="payment-summary__your-bill-header" data-ci="payment-summary__your-bill-header">
            {{ pageAttr.billing_summary_your_bill_header }}
        </h4>

        <div class="payment-summary__two-col">
            <div data-testid="first-payment" class="payment-summary__first-payment-gap">
                {{ pageAttr.billing_summary_first_payment_label }}
            </div>
            <div class="payment-summary__first-payment-gap">
                {{ nextBillingDate }}
            </div>
        </div>
        <recurly-account-balance
            v-if="showGiftBalance"
            :isFTC="isFTC"
            :pageAttr="pageAttr"></recurly-account-balance>
        <div class="payment-summary__two-col">
            <div class="col">
                {{ pageAttr.billing_summary_total_label }}
            </div>
            <div class="col">
                <span
                    translate="no"
                    class="next-nonzero-billing-price notranslate"
                    data-ci="next-nonzero-billing-price">
                    {{ nextNonZeroBillingPrice }}
                </span>
            </div>
        </div>
        <div
            data-testid="totalDisclaimer"
            class="payment-summary__details-text payment-summary__single-col-gap-details"
            v-bind:class="[disclaimerCopyEl ? 'payment-summary__first-payment-gap' : '']">
            {{ pageAttr.billing_summary_tax_disclaimer }}
        </div>
        <template v-if="pageAttr.billing_summary_minimum_term_enabled">
            <div data-testid="showMinimumTerm" class="payment-summary__two-col">
                <div class="col">
                    {{ pageAttr.billing_summary_minimum_term }}
                </div>
                <div data-testid="minTermValue" class="col">
                    {{
                        plan && plan.planType === planTypeMonthly
                            ? pageAttr.billing_summary_minimum_term_monthly
                            : pageAttr.billing_summary_minimum_term_annual
                    }}
                </div>
            </div>
            <div
                data-testid="showMinimumTermAutoRenewal"
                class="payment-summary__details-text payment-summary__details-text--left payment-summary__single-col-gap-details">
                {{ pageAttr.billing_summary_minimum_term_auto_renewal }}
            </div>
        </template>
        <template v-if="disclaimerCopyEl">
            <div class="payment-summary__section-border"></div>
            <div class="payment-summary__disclaimer" v-html="disclaimerCopyEl"></div>
        </template>
    </div>
</template>

<script>
    import RecurlyAccountBalance from 'aa/vue/components/account/pages/accountMain/sections/parts/RecurlyAccountBalance';
    import Product from 'aa/vue/models/Product';
    export default {
        name: 'BillingPaymentSummary',
        components: {
            RecurlyAccountBalance,
        },
        props: {
            countryClass: {
                type: String,
            },
            disclaimerCopyEl: {
                type: String,
            },
            nextBillingDate: {
                type: String,
            },
            pageAttr: {
                type: Object,
            },
            nextNonZeroBillingPrice: {
                type: String,
            },
            showGiftBalance: {
                type: Boolean,
                default: false,
            },
            isFTC: {
                type: Boolean,
                default: false,
            },
            plan: {
                type: Object,
            },
        },
        data() {
            return {
                planTypeMonthly: Product.TYPE_MONTHLY,
            };
        },
    };
</script>
